import { createContext } from 'react';

export const RefreshLogoContext = createContext(false);
